<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
    <div style="" v-if="pedido" :pedido="this.pedido">
      <div>
        <div
          class="logo"
          :style="
            'background-color:' + this.$store.state.empresa.cor_secundaria
          "
        >
          <div class="content">
            <img
              :src="
                this.$store.state.url_files +
                'logos/' +
                this.$store.state.empresa.logo
              "
              alt="Logo"
              :style="
                'height: 70px; border-radius: 10px;border-style: solid;border-width: 5px;width: auto; border-color:' +
                this.$store.state.empresa.cor_splash_borda_logo
              "
            />
          </div>
        </div>
      </div>

      <div id="reciboDigitalImp">
        <div aling="center" style="text-align: center">
          <h5 style="font-family: monospace">
            <strong style="font-weight: 700"
              ><i class="far fa-sticky-note"></i> RECIBO DIGITAL</strong
            >
          </h5>
        </div>
        <br />

        <div class="" style="padding-left: 5px; padding-right: 5px">

          <table class="highlight">
            <thead>
              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>NÚMERO DO PEDIDO</th>
                    <!-- <th class="right">CÓDIGO</th> -->
                  </tr>
                  <tr>
                    <td>
                      #{{
                        this.NumeroPedidoFormatado(pedido.pedido.numero_pedido)
                      }}
                    </td>
                    <!-- <td class="right">
                      {{ pedido.pedido.codigo_rastreamento }}
                    </td> -->
                  </tr>
                </table>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>DATA</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        moment
                          .utc(pedido.pedido.created_at)
                          .tz("America/Porto_Velho")
                          .format("DD/MM/YYYY HH:mm")
                      }}
                    </td>
                  </tr>
                </table>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>DETALHES</th>
                  </tr>
                  <tr>
                    <td>
                      <div style="width: 100% !important;" v-html="pedidoHtml"></div>
                    </td>
                  </tr>
                </table>

              </tr>


              <!-- <tr>
                <table style="position: relative">
                  <tr>
                    <th>ITENS</th>
                    <th class="right">VALOR</th>
                  </tr>
                </table>
              </tr> -->
            </thead>
            <!-- <tbody>
              <tr v-for="pedido in pedido.pedido.itens">
                <table style="position: relative; height: 0px">
                  <tr>
                    <td style="width: 65%">
                      {{
                        LimitarCaracteres(
                          pedido.quantidade + "x " + pedido.produto.nome,
                          25
                        )
                      }}
                    </td>
                    <td class="right" style="padding-top: 7px">
                      R$ {{ pedido.valor_total }}
                    </td>
                  </tr>
                </table>

                <table
                  v-if="pedido.adicionais.length > 0"
                  style="position: relative"
                >
                  <tr v-for="adicional in pedido.adicionais">
                    <td>
                      &nbsp;&nbsp;
                      {{
                        LimitarCaracteres(
                          " " +
                            (adicional.quantidade == (undefined || 0)
                              ? 1
                              : adicional.quantidade || 1) *
                              pedido.quantidade +
                            "x" +
                            " " +
                            adicional.adicional_nome,
                          25
                        )
                      }}
                    </td>
                    <td class="right" style="">
                      R$
                      {{
                        parseFloat(
                          adicional.adicional_valor *
                            (adicional.quantidade == (undefined || 0)
                              ? 1
                              : adicional.quantidade || 1) *
                            pedido.quantidade
                        ).toFixed(2)
                      }}
                    </td>
                  </tr>
                </table>

                <table v-if="pedido.grade" style="position: relative">
                  <tr>
                    <td>
                      &nbsp;&nbsp;
                      {{
                        LimitarCaracteres(
                          " " + "Tamanho: " + " " + pedido.grade,
                          25
                        )
                      }}
                    </td>
                  </tr>
                </table>

                <table v-if="pedido.cor" style="position: relative">
                  <tr>
                    <td>
                      &nbsp;&nbsp;
                      {{
                        LimitarCaracteres(" " + "Cor: " + " " + pedido.cor, 25)
                      }}
                    </td>
                  </tr>
                </table>
              </tr>
            </tbody> -->
            <tfoot>
              <!-- <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>SUBTOTAL</th>
                    <td class="right">
                      R$
                      {{
                        pedido.pedido.subtotal ? pedido.pedido.subtotal : "0.00"
                      }}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>DESCONTO</th>
                    <td class="right">
                      R$ {{ pedido.pedido.valor_desconto || "0.00" }}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr v-if="pedido.pedido.forma_entrega == 'ENTREGA'">
                <table style="position: relative; height: auto">
                  <tr>
                    <th>TAXA ENTREGA</th>
                    <td class="right">
                      R$
                      {{
                        pedido.pedido.taxa_entrega > 0
                          ? pedido.pedido.taxa_entrega
                          : "0.00"
                      }}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>VALOR TOTAL</th>
                    <td class="right">
                      <span
                        v-if="
                          pedido.pedido.valor_desconto &&
                          pedido.pedido.valor_desconto > 0
                        "
                      >
                        <strike>R$ {{ pedido.pedido.subtotal }}</strike>
                        R$ {{ pedido.pedido.valor_total }}
                      </span>
                      <span v-else> R$ {{ pedido.pedido.valor_total }} </span>
                    </td>
                  </tr>
                </table>
              </tr>

              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>FORMA DE PAGAMENTO</th>
                  </tr>
                  <tr>
                    <td>
                      {{ pedido.pedido.forma_pagamento }}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr v-if="pedido.pedido.forma_pagamento == 'PIX'">
                <table style="position: relative; height: auto">
                  <tr>
                    <th>PIX - TIPO DE CHAVE</th>
                  </tr>
                  <tr>
                    <td>
                      {{this.$store.state.empresa.pagamento_pix_chave_tipo}}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr v-if="pedido.pedido.forma_pagamento == 'PIX'">
                <table style="position: relative; height: auto">
                  <tr>
                    <th>PIX - CHAVE</th>
                  </tr>
                  <tr>
                    <td>
                      {{this.$store.state.empresa.pagamento_pix_chave}}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr v-if="pedido.pedido.forma_pagamento == 'PIX'">
                <table style="position: relative; height: auto">
                  <tr>
                    <th>PIX - NOME</th>
                  </tr>
                  <tr>
                    <td>
                      {{this.$store.state.empresa.pagamento_pix_nome_conta}}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>FORMA DE RECEBIMENTO DO ITEM</th>
                  </tr>
                  <tr>
                    <td>
                      {{ pedido.pedido.forma_entrega }}
                    </td>
                  </tr>
                </table>
              </tr>-->

              <!-- <br v-if="pedido.pedido.forma_entrega == 'ENTREGA'" /> -->

              <!-- <tr v-if="pedido.pedido.forma_entrega == 'ENTREGA'">
                <table style="position: relative; height: auto">
                  <tr>
                    <th>LOCAL ENTREGA</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        pedido.pedido.entrega_endereco +
                        ", " +
                        pedido.pedido.entrega_numero +
                        (pedido.pedido.entrega_complemento != null
                          ? " - " + pedido.pedido.entrega_complemento
                          : "") +
                        " - " +
                        pedido.pedido.entrega_bairro
                      }}
                      -
                      {{
                        pedido.pedido.entrega_cidade +
                        "/" +
                        pedido.pedido.entrega_uf
                      }}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>NOME CLIENTE</th>
                  </tr>
                  <tr>
                    <td>
                      {{ pedido.pedido.nome_cliente }}
                    </td>
                  </tr>
                </table>
              </tr>

              <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>TELEFONE CLIENTE</th>
                  </tr>
                  <tr>
                    <td>
                      {{ pedido.pedido.telefone }}
                    </td>
                  </tr>
                </table>
              </tr>  -->

              <!-- <br /> -->

              <!-- <br /> -->

              <!-- <tr>
                <table style="position: relative; height: auto">
                  <tr>
                    <th>DATA DO PEDIDO</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        moment
                          .utc(pedido.pedido.created_at)
                          .tz("America/Porto_Velho")
                          .format("DD/MM/YYYY HH:mm")
                      }}
                    </td>
                  </tr>
                </table>
              </tr> -->

              <!-- <br /> -->

              <tr>
                <table
                  style="position: relative; height: auto"
                  v-if="pedido.pedido.created_at != pedido.pedido.updated_at"
                >
                  <tr>
                    <th>ÚLTIMA ATUALIZAÇÃO</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        moment
                          .utc(pedido.pedido.updated_at)
                          .tz("America/Porto_Velho")
                          .format("DD/MM/YYYY HH:mm")
                      }}
                    </td>
                  </tr>
                </table>
              </tr>


            </tfoot>
          </table>
        </div>
      </div>


      <br />
      <br />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import momentTz from 'moment-timezone'

export default {
  components: { Loading },
  data() {
    return {
      pedido: null,
      isLoading: false,
      fullPage: true,
      pedidoHtml: "<br>"
    };
  },
  name: "DigitalReceiptView",
  beforeCreate(){
    momentTz.tz.setDefault("America/Porto_Velho")
  },
  async mounted() {
    this.isLoading = true;
    this.getPedido();
    document.getElementById("bodyMain").style =
      "background-color: rgb(255 255 227)";
  },
  methods: {
    LimitarCaracteres(conteudo, tamanho) {
      var content = conteudo;
      var limit = parseInt(tamanho);
      if (content.length > limit) {
        return content.slice(0, limit) + "...";
      } else {
        return content + "";
      }
    },
    NumeroPedidoFormatado(numero) {
      var strNumPedido = numero.toString();
      var pad = "00000";
      strNumPedido =
        pad.substring(0, pad.length - strNumPedido.length) + strNumPedido;
      return strNumPedido;
    },
    async getPedido() {
      await axios
        .get(
          this.$store.state.apiUrl +
            "empresa/" +
            this.$router.currentRoute.params.empresa +
            "/recibo-digital/" +
            this.$router.currentRoute.params.pedido
        )
        .then((res) => {
          if (res.data && res.data != null) {
            this.pedido = res.data;
            this.pedidoHtml = res.data.pedido.pedido_html;
            this.$store.commit("empresa", this.pedido.empresa);
            this.isLoading = false;
          } else {
            Swal.fire({
              title: "Aviso",
              text: "Recibo não localizado ou não existe :(",
              icon: "error",
              customClass: {
                confirmButton: "confirm-button-class materialize-red",
              },
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          Swal.fire({
            title: "Aviso",
            text: "Recibo não localizado ou não existe :(",
            icon: "error",
            customClass: {
              confirmButton: "confirm-button-class materialize-red",
            },
          });
        });
    },
  },
};
</script>


<style scoped>
body {
  margin: 0;
  background-color: #f1f1d5 !important;
}

#bodyMain {
  background-color: #f1f1d5 !important;
}

.btn {
  height: 20px;
  line-height: 13px;
  font-size: 11px;
}
td,
th {
  padding: 3px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
#reciboDigitalImp {
  margin: 10px auto;
}
.content-e {
  text-align: center;
}
.inner-e {
  display: inline-block;
}
.valid-badge {
  position: absolute;
  top: 10px;
  right: 12px;
}
.valid-check {
  position: absolute;
  top: 2px;
  right: 12px;
}

tr {
  height: 0px;
}

.logo {
  z-index: 10;
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transition: all 0.3s ease 0s;
  background: rgb(111, 173, 228);
}
.logo .content {
  width: 100%;
  height: 100px;
  max-width: 1200px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding: 30px;
}
.logo .content > img {
  height: 60px;
  width: 100%;
}

.logo {
  z-index: 10;
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transition: all 0.3s ease 0s;
  background: #ee6e73;
}
</style>



// WEBPACK FOOTER //
// src/app/views/DigitalReceiptView.vue